import type {ReactElement} from 'react';
import React from 'react';
import {PosterEditingBaseColorPanel} from '@Components/poster-editor/components/poster-editing-side-panel/components/poster-editing-base-color-panel';
import type {ColorStorage} from '@Components/color-picker-v2';
import {getColorObjectArrayFromFillColor, getRGBAArrayFromColorStorage} from '@Utils/color.util';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromTableItem} from '@Hooks/poster-editor/useGetKeyFromTableItem';

export function LayoutBackgroundColorPanel(): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const itemBackgroundItem = useGetKeyFromTableItem('itemBackgroundColor');

  if (!activeItem || (activeItem && !('itemBackgroundColor' in activeItem)) || !itemBackgroundItem) {
    throw new Error("active item doesn't have background color property");
  }

  const getBackgroundColors = (): ColorStorage[] => {
    return getColorObjectArrayFromFillColor([itemBackgroundItem]);
  };

  const onChangeColor = (updatedColor: ColorStorage[]): void => {
    void activeItem.updateFromObject(
      {
        itemBackgroundColor: getRGBAArrayFromColorStorage(updatedColor)[0],
      },
      {
        undoable: false,
      }
    );
  };

  const onChangeColorEnded = (updatedColor: ColorStorage[]): void => {
    void activeItem.updateFromObject({
      itemBackgroundColor: getRGBAArrayFromColorStorage(updatedColor)[0],
    });
  };

  return (
    <PosterEditingBaseColorPanel
      id="menu-background-color-panel"
      color={getBackgroundColors()}
      isGradientEnabled={false}
      onChangeColor={onChangeColor}
      onChangeEnded={onChangeColorEnded}
    />
  );
}
